<script setup lang="ts">
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
const isScrolled = ref(false);
const toTopWrapper = ref<HTMLElement | null>(null);

function toTop() {
	window.scrollTo({
		top: 0,
		behavior: "smooth",
	});
}

onMounted(() => {
	window.addEventListener("scroll", checkScroll);
});
onUnmounted(() => {
	window.removeEventListener("scroll", checkScroll);
});
function checkScroll() {
	isScrolled.value = window.scrollY > 0;
	if (toTopWrapper?.value) {
		toTopWrapper.value.style.opacity = isScrolled.value ? "1" : "0";
	}
}
</script>

<template lang="pug">
.footer-bar-bottom-button-to-top-wrapper(v-if="isScrolled", ref="toTopWrapper")
	.footer-bar-bottom-button-to-top(@click="toTop")
		i-fa-angle-up.footer-bar-bottom-button-to-top-icon
	a.footer-bar-bottom-button-phone(
		href="tel:+38163267266",
		aria-label="Call us",
		@click="store.trackClickCall()"
	)
		i-fa-phone.footer-bar-bottom-button-to-top-icon
		.footer-bar-bottom-button-call-us-text {{ $t("app.callUs") }}
</template>

<style lang="scss" scoped>
.footer-bar-bottom-button-to-top-wrapper {
	width: 70px;
	height: 70px;
	position: fixed;
	bottom: 18px;
	right: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: rgba(234, 189, 117, 0.2);
	cursor: pointer;
	z-index: 3;
	opacity: 0;
	transition: opacity 1s ease;

	.footer-bar-bottom-button-to-top,
	.footer-bar-bottom-button-phone {
		width: 60px;
		height: 60px;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background-color: $app-accent-color1;
		z-index: 2;
		display: none;
		position: relative;

		.footer-bar-bottom-button-to-top-icon {
			width: 40%;
			height: 40%;
		}

		.footer-bar-bottom-button-call-us-text {
			position: absolute;
			right: 130%;
			top: 50%;
			transform: translateY(-50%);
			height: 30px;
			background-color: $app-accent-color1;
			width: 120px;
			border-radius: 20px;
			font-family: "Galano Grotesque", sans-serif;
			font-weight: 800;
			text-transform: uppercase;
			font-size: 12px;
			margin: 0;
			padding: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 11px;
			animation: move-left 4s infinite;
		}
	}

	.footer-bar-bottom-button-phone {
		display: flex;
	}

	&:hover {
		background-color: transparent;
		&::before {
			content: "";
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			border-radius: inherit;
			background-color: rgb(234, 189, 117, 0.5);
			animation: pulse 1.2s infinite alternate;
		}
	}
}

@keyframes pulse {
	0% {
		transform: scale(0.8);
	}
	100% {
		transform: scale(1);
	}
}

@media screen and (width >= 1024px) {
	.footer-bar-bottom-button-to-top-wrapper {
		width: 40px;
		height: 40px;
		position: fixed;
		bottom: 18px;
		right: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background-color: rgba(234, 189, 117, 0.2);
		cursor: pointer;
		z-index: 3;
		opacity: 0;
		transition: opacity 1s ease;

		.footer-bar-bottom-button-to-top {
			width: 30px;
			height: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 50%;
			background-color: $app-accent-color1;
			z-index: 2;

			.footer-bar-bottom-button-to-top-icon {
				width: 40%;
				height: 40%;
			}
		}

		.footer-bar-bottom-button-phone {
			display: none;
		}

		&:hover {
			background-color: transparent;
			&::before {
				content: "";
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				border-radius: inherit;
				background-color: rgb(234, 189, 117, 0.5);
				animation: pulse 1.2s infinite alternate;
			}
		}
	}
}

@media screen and (width >= 1024px) {
	.footer-bar-bottom-button-to-top-wrapper {
		width: 70px !important;
		height: 70px !important;

		.footer-bar-bottom-button-to-top {
			width: 50px !important;
			height: 50px !important;
		}
	}
}
</style>
